import Card from "./shared/Card.jsx";
import RatingSelect from "./RatingSelect.jsx";
import Button from "./shared/Button";
import { useContext, useState, useEffect } from "react";
import FeedbackContext from "../context/FeedbackContext.js";

function FeedbackForm() {
  const { addFeedback, feedbackEdit, updateFeedback } =
    useContext(FeedbackContext);
  const [text, setText] = useState("");
  const [rating, setRating] = useState("");
  const [btnDisable, setbtnDisable] = useState("True");
  const [message, setMessage] = useState("");

  useEffect(() => {
    //loads imediately the page is loaded
    if (feedbackEdit.edit === true) {
      setbtnDisable(false);
      setText(feedbackEdit.item.text);
      setRating(feedbackEdit.item.rating);
    }
  }, [feedbackEdit]);

  const handleTextChanges = (e) => {
    if (text === "") {
      setMessage(null);
      setbtnDisable(true);
    }

    if (text !== "" && text.trim().length < 10) {
      setMessage("Text must be at least 10 characters");
      setbtnDisable(true);
    } else {
      setMessage(null);
      setbtnDisable(false);
    }

    setText(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim().length > 10) {
      const newFeedback = {
        text,
        rating,
      };

      if (feedbackEdit.edit === true) {
        updateFeedback(feedbackEdit.item.id, newFeedback)
        ;
      } else {
        addFeedback(newFeedback);
      }

      setText("");
      setbtnDisable(true);
      setRating("");
    }
  };

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <h2>How would you rate your service with us</h2>
        <RatingSelect select={(rating) => setRating(rating)} />
        <div className="input-group">
          <input
            onChange={handleTextChanges}
            type="text"
            value={text}
            placeholder="Write a review"
          />
          <Button type="submit" isDisabled={btnDisable}>
            Send
          </Button>
        </div>
        {message && <div className="message"> {message} </div>}
      </form>
    </Card>
  );
}

export default FeedbackForm;
